import { FormControl, MenuItem, Select } from '@material-ui/core';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { replaceAll } from '../../../global/helpers/string-helpers';
import { TcsmStates } from '../../../root/tcsm-model';
import { ClergyCompReportSettings } from '../../arc/models/arc-epi-props';
import { handleInternationalDioClick } from '../map-actions';

const list = ['Colombia', 'Cuba', 'Dominican Republic', 'Central Ecuador', 'Litoral Ecuador', 'Honduras', 'Haiti', 'Puerto Rico', 'Venezuela', 'Virgin Islands', 'Convocation of Episcopal Churches in Europe', 'Taiwan'];

export function InternationalDropdown() {

	const seletedDio = useSelector<TcsmStates, string>(state => state?.clergyCompReportState.selectedDio);
	const settings = useSelector<TcsmStates, ClergyCompReportSettings>(state => state?.epiProps?.clergyCompReportSettingsState?.epiContent);

	const dispatch = useDispatch();
	const handleChange = (evt) => {
		const svg = document.getElementById('international-svg');
		let diocese = null;
		const allDio = [];
		svg.childNodes.forEach(d => {
			if (d.nodeName === 'g') {
				allDio.push(d);
				if ((d as HTMLElement)?.getAttribute('id') === evt?.target?.value)
					diocese = d;
			}

		});

		handleInternationalDioClick(diocese as HTMLElement, allDio, dispatch);

	};

	return (
		<FormControl >
			<Select
				value={seletedDio}
				onChange={handleChange}
				placeholder={settings?.nonDomesticDioceseLabel}
				displayEmpty
				renderValue={(selected: any) => {
					if (!selected || selected?.length === 0) {
						return <em>{settings?.nonDomesticDioceseLabel}</em>;
					}
					const link = list?.filter(a => a === replaceAll(selected?.replace('Dio_', ''), '_', ' '));
					return link[0];
				}}
			>
				{
					list?.map(a => <MenuItem key={a} value={`Dio_${replaceAll(a, ' ', '_')}`}>{a}</MenuItem>)
				}

			</Select>
		</FormControl>
	);
}